'use client';

import { c as _c } from "react/compiler-runtime";
import { Popover as RedesignPopover } from '@systemeio/components';
import { useState, type ReactElement, type ReactNode } from 'react';
interface PopoverProps {
  label: ReactNode;
  children: (open: boolean) => ReactNode;
  className?: string;
  position?: 'top' | 'bottom';
  trigger?: ReactElement;
}
function Popover(t0) {
  const $ = _c(16);
  const {
    children,
    className,
    label,
    position: t1,
    trigger
  } = t0;
  const position = t1 === undefined ? "top" : t1;
  const [open, setOpen] = useState(false);
  const accessibleLabel = typeof label === "string" ? label : undefined;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = nextOpen => setOpen(nextOpen);
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== open) {
    t3 = {
      open,
      onOpenChange: t2
    };
    $[1] = open;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== accessibleLabel || $[4] !== trigger) {
    t4 = {
      "aria-label": accessibleLabel,
      render: trigger
    };
    $[3] = accessibleLabel;
    $[4] = trigger;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== children || $[7] !== open) {
    t5 = children(open);
    $[6] = children;
    $[7] = open;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== className || $[10] !== label || $[11] !== position || $[12] !== t3 || $[13] !== t4 || $[14] !== t5) {
    t6 = <RedesignPopover className={className} label={label} popoverClassName="p-3" rootProps={t3} side={position} triggerProps={t4}>{t5}</RedesignPopover>;
    $[9] = className;
    $[10] = label;
    $[11] = position;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}
export { Popover };
export type { PopoverProps };